// Just the modules necessary for initial render!
const CoreLayout = require("../layouts/CoreLayout");
const Home = require("./home");
const Login = require("./login");
const Portfolio = require("./portfolio");
const ForgotPassword = require("./forgot-password");
const PasswordReset = require("./password-reset");
const UpdateEmail = require("./update-email");
const Instructions = require("./instructions");
const BodyModelNew = require("./body-model-new");
const BodyModelPreview = require("./body-model-preview");
const BodyModelEdit = require("./body-model-edit");
const Pricing = require("./pricing");
const CreateAccount = require("./create-account");
const PurchasedBodyModelView = require("./purchased-body-model-view");
const RenderTest = require("./render-test");
const AdminDashboard = require("./admin-dashboard");
const AdminGiftCredits = require("./admin-gift-credits");
const AdminPromoCodes = require("./admin-promocodes");
const AdminPromoCodesAdd = require("./admin-promocodes-add");
const AdminPromoCodesEdit = require("./admin-promocodes-edit");
const AdminUsers = require("./admin-users");

// Create routes
module.exports = store => [
    Home,
    {
        path: "/",
        component: CoreLayout,
        childRoutes: [
            AdminDashboard,
            AdminGiftCredits,
            AdminPromoCodes,
            AdminPromoCodesAdd,
            AdminPromoCodesEdit,
            AdminUsers,
            Login,
            Portfolio,
            ForgotPassword,
            PasswordReset,
            UpdateEmail,
            Instructions,
            BodyModelNew,
            BodyModelPreview,
            ...Pricing,
            BodyModelEdit,
            CreateAccount,
            PurchasedBodyModelView,
            RenderTest
        ]
    }
];



// WEBPACK FOOTER //
// ./src/routes/index.js